import { createSlice } from "@reduxjs/toolkit";
import { fetchDoctorWalletWithdrawalsReducer } from "../../reducer/withdrawals/fetchDoctorWalletWithdrawalsReducer";

import i18n from "../../i18n";
const initialState = {
  data: [],
  total: 0,
  page: 1,
  limit: 10,
  isLoading: false,
  error: null,
};

const doctorWalletWithdrawalsSlice = createSlice({
  name: "doctorWalletWithdrawals",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDoctorWalletWithdrawalsReducer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        fetchDoctorWalletWithdrawalsReducer.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.data = action.payload?.withdrawals || [];
          state.total = action.payload?.total || 0;
          state.page = action.meta.arg?.page || 1;
          state.limit = action.meta.arg?.limit || 10;

          console.log("✅ Wallet Withdrawals Loaded:", action.payload);
        },
      )
      .addCase(
        fetchDoctorWalletWithdrawalsReducer.rejected,
        (state, action) => {
          state.isLoading = false;
          state.error =
            action.payload || i18n.t("toast.failedToLoadWalletWithdrawalsList");
        },
      );
  },
});

export default doctorWalletWithdrawalsSlice.reducer;
